<template>
  <div class="mt-4">
    <load-and-error :loading="loading" :error="error" :can-retry="canRetry" @retry="refresh()"></load-and-error>

    <div v-if="!loading && !error && part">
        <h1 class="mb-4">
            <router-link :to="{name: 'part', params: {id: part.id}}">
                <i class="fa fa-chevron-left mr-2"></i>
            </router-link>

            <span v-if="isAdd">Add Stock:</span>
            <span v-else>Remove Stock:</span>
            {{part.name}}
        </h1>

        <form @submit.prevent>
            <div class="form-group">
                <label for="quantity">Quantity</label>
                <input type="number" class="form-control" id="quantity" v-model="stock.quantity" :disabled="saving" min="1" />
            </div>

            <div class="form-group" v-if="isAdd">
                <label for="price">Price</label>
                <input type="number" class="form-control" id="price" v-model="stock.price" :disabled="saving" min="0" step="0.01" />
            </div>

            <div class="form-group">
                <label for="location">Location</label>
                <select class="form-control" id="location" v-model="stock.location" :disabled="saving">
                    <option v-for="(display, location) in LOCATIONS" :key="location" :value="location">{{display}}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="storage">Storage</label>
                <input type="text" class="form-control" id="storage" v-model="stock.storage" :disabled="saving" />
            </div>

            <div class="form-group" v-if="isAdd">
                <label for="supplier">Supplier</label>
                <input type="text" class="form-control" id="supplier" v-model="stock.supplier" :disabled="saving" />
            </div>

            <div class="form-group" v-if="!isAdd">
                <label for="work_order_type">Work Order Type</label>
                <select class="form-control" id="work_order_type" v-model="stock.work_order_type" :disabled="saving">
                    <option
                        v-for="workOrderType in workOrderTypes"
                        :key="workOrderType.id"
                        :value="workOrderType.id"
                    >{{workOrderType.name}}</option>
                </select>
            </div>

            <div class="form-group" v-if="!isAdd">
                <label for="unit">Unit</label>
                <select class="form-control" id="unit" v-model="stock.unit" :disabled="saving">
                    <option value="none">None</option>
                    <option value="truck">Truck</option>
                    <option value="trailer">Trailer</option>
                </select>
            </div>

            <div class="form-group" v-if="!isAdd && stock.unit != 'none'">
                <label for="unit_number">Unit Number</label>
                <input type="text" class="form-control" id="unit_number" v-model="stock.unit_number" :disabled="saving" />
            </div>

            <div class="form-group" v-if="!isAdd">
                <label for="charge">Charge</label>
                <input type="text" class="form-control" id="charge" v-model="stock.charge" :disabled="saving" />
            </div>

            <div class="form-group">
                <label for="notes">Notes</label>
                <textarea class="form-control" id="notes" v-model="stock.notes"></textarea>
            </div>
        </form>

        <div class="row mt-4 mb-4">
            <div class="col-12 col-md-4 offset-md-8">
                <button class="btn btn-success w-100" @click="save()" :disabled="saving">
                    <i class="fa fa-save mr-2"></i>
                    Save
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import miniToastr from 'mini-toastr';

import api from 'ays-shared/api';
import utils from 'ays-shared/utils';
import constants from '@/constants';

export default {
  name: 'ChangeStock',
  data() {
    return {
      loading: false,
      saving: false,
      error: '',
      part: null,
      canRetry: false,
      stock: null,
      LOCATIONS: constants.LOCATIONS,
    };
  },
  mounted() {
    this.refresh();
  },
  computed: {
    ...mapState({ workOrderTypes: (state) => state.cache.workOrderTypes }),
    isAdd() {
      return this.$route.name == 'add_stock';
    },
  },
  methods: {
    async refresh() {
      this.error = '';
      this.loading = true;
      this.canRetry = true;

      try {
        this.part = await api.inventory.get(this.$route.params.id);
        this.stock = {
          part: this.part.id,
          location: this.part.default_location,
          storage: this.part.default_storage,
          supplier: this.part.default_supplier,
          notes: '',
          price: 0,
          quantity: 1,
          work_order_type: null,
          unit: 'none',
          unit_number: '',
          charge: '',
        };
      }
      catch (err) {
        this.part = null;
        this.error = utils.errorMessage(err);
        utils.captureException(err, 'ChangeStock');
      }
      finally {
        this.loading = false;
      }
    },
    async save() {
      this.error = '';
      this.saving = true;
      this.canRetry = false;

      try {
        this.stock.quantity = this.isAdd ? this.stock.quantity : (-1 * this.stock.quantity);
        this.stock.price = utils.forceNumber(this.stock.price, 0);

        await api.inventory.stock.create(this.stock);
        miniToastr.success('Updated stock');
        this.$router.push({ name: 'part', params: { id: this.part.id } });
      }
      catch (err) {
        utils.handleNetworkError(err, 'Error updatig stock', 'ChangeStock.save');
      }
      finally {
        this.saving = false;
      }
    },
  },
};
</script>
